import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import StatusBadge from "../../components/StatusBadge";
import { Button } from "../../components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { GraduationCap, Check, X } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

const STATUS_LABELS = {
  awaiting_scholarship_verification: "Awaiting Verification",
  awaiting_documents: "Awaiting Documents",
  pending_approval: "Pending Approval",
  confirmed: "Confirmed",
  waitlisted: "Waitlisted",
  cancelled: "Cancelled",
};

export default function AdminScholarship() {
  const [rows, setRows] = useState([]);

  const load = () => api.get("/admin/scholarship-registrations").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try { await api.put(`/admin/registrations/${id}/scholarship`, { action }); toast.success("Updated."); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <AppShell admin>
      <div className="flex items-center gap-2">
        <GraduationCap className="h-6 w-6 text-brandblue" />
        <h1 className="font-display text-3xl font-bold text-navy">Scholarship Registrations</h1>
      </div>
      <p className="text-slateBrand">Step Up For Students registrations. Reservations are tracked separately from payments received — reserved funds are never counted as collected revenue.</p>

      <div className="mt-8 overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <Table>
          <TableHeader><TableRow><TableHead>Parent</TableHead><TableHead>Student(s)</TableHead><TableHead>Service</TableHead><TableHead>Amount</TableHead><TableHead>Reservation</TableHead><TableHead>Status</TableHead><TableHead>Actions</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id} data-testid={`scholarship-row-${r.id}`}>
                <TableCell className="text-sm font-semibold text-navy">{r.parent_name}<div className="text-xs font-normal text-slateBrand">{r.parent_email}</div></TableCell>
                <TableCell className="text-sm">{(r.students || []).join(", ")}</TableCell>
                <TableCell className="text-sm">{r.service}</TableCell>
                <TableCell className="text-sm font-semibold text-navy">${(r.amount || 0).toFixed(2)}</TableCell>
                <TableCell>{r.scholarship?.reservation_submitted ? <span className="inline-flex items-center gap-1 text-xs font-semibold text-successBrand"><Check className="h-3.5 w-3.5" />Submitted</span> : <span className="inline-flex items-center gap-1 text-xs text-slateBrand"><X className="h-3.5 w-3.5" />Not yet</span>}</TableCell>
                <TableCell><StatusBadge status={r.scholarship?.verified ? "complete" : "pending"} label={STATUS_LABELS[r.status] || r.status} /></TableCell>
                <TableCell>
                  <div className="flex flex-wrap gap-1">
                    <Button size="sm" variant="outline" data-testid={`scholarship-verify-${r.id}`} onClick={() => act(r.id, "verified")} className="text-xs text-successBrand">Verify</Button>
                    <Button size="sm" variant="outline" data-testid={`scholarship-approve-${r.id}`} onClick={() => act(r.id, "approve")} className="text-xs">Approve</Button>
                    <Button size="sm" variant="outline" onClick={() => act(r.id, "request_info")} className="text-xs">Request Info</Button>
                    <Button size="sm" variant="outline" onClick={() => act(r.id, "payment_received")} className="text-xs">Payment Received</Button>
                    <Button size="sm" variant="outline" onClick={() => act(r.id, "cancel")} className="text-xs text-alertBrand">Cancel</Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={7} className="py-8 text-center text-slateBrand">No scholarship registrations yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </AppShell>
  );
}
